import React, { useState } from "react";
import { Row, Col, Button, Form, Input, notification } from "antd";
import axios from "axios";

const CreateAdmin = (props) => {
  const { setDrawerVisibility, setRefetch } = props;
  const [btnLoading, setBtnLoading] = useState(false);
  const handleFormSubmit = (values) => {
    const { firstName, lastName, email, password } = values;
    setBtnLoading(true);
    let formData = new FormData();
    formData.append("FirstName", firstName);
    formData.append("LastName", lastName);
    formData.append("Email", email);
    formData.append("Password", password);

    axios("/api/Account/Register", {
      method: "POST",
      data: formData,
    })
      .then((response) => {
        setBtnLoading(false);
        notification["success"]({
          message: "Success",
          description: "Admin Created Successfully!",
        });
        setDrawerVisibility(false);
        setRefetch((prev) => !prev);
      })
      .catch((err) => {
        setBtnLoading(false);
        notification.error({
          message: "Error",
          description: "Unable to Create Admin!",
        });
        console.log(err);
      });
  };

  return (
    <Form onFinish={handleFormSubmit} requiredMark={false}>
      <Row>
        <Col span={24}>
          <Form.Item
            name="firstName"
            label="First Name"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Please input first name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="lastName"
            label="Last Name"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Please input last name!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="email"
            label="Email"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Please input email!",
              },
              {
                type: "email",
                message: "Please input valid email!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="password"
            label="Password"
            labelCol={{ span: 24 }}
            rules={[
              {
                required: true,
                message: "Please input a password!",
              },
              { min: 5, message: "Password must contains minimum 5 characters!" },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item
            name="confirm"
            label="Confirm Password"
            labelCol={{ span: 24 }}
            dependencies={["password"]}
            rules={[
              {
                required: true,
                message: "Please confirm your password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Password doesn't match!"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button loading={btnLoading} type="primary" htmlType="submit">
          Create
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CreateAdmin;
